import {
  LOGIN_INIT,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  UPDATE_VALUE,
  LOGOUT_SUCCESS
} from "./constants";
import { LoginActions } from "./types";
import { AuthModel } from "./model";

import { TOKEN_KEY } from "../../../../configs";
import { saveToLocal, getFromLocal } from "../../../../utils/cache";

const initialState: AuthModel = {
  username: "",
  password: "",
  isLoading: false,
  isLoggedIn: false,
  token: getFromLocal(TOKEN_KEY, false) || null,
};

const auth = (
  state: AuthModel = initialState,
  action: LoginActions,
): AuthModel => {
  switch (action.type) {
    case LOGIN_INIT: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case LOGIN_SUCCESS: {
      const tokenData = saveToLocal(
        TOKEN_KEY,
        action.data.accessToken.jwtToken,
        false,
      );
      return {
        ...state,
        token: tokenData || null,
        isLoading: false,
        isLoggedIn: true,
      };
    }

    case LOGOUT_SUCCESS: {
      return {
        ...initialState,
        token: null,
      };
    }

    case LOGIN_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case UPDATE_VALUE: {
      return {
        ...state,
        [action.key]: action.value,
      };
    }

    default:
      return state;
  }
};
export default auth;
